import { render, staticRenderFns } from "./OnlinePayment.vue?vue&type=template&id=b8f6eaa6&"
import script from "./OnlinePayment.vue?vue&type=script&lang=js&"
export * from "./OnlinePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports